var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.916016,
    y: 0.951172,
    width: 38,
    height: 38,
    rx: 6,
    fill: "#F4D35E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9257 21.6661C27.4441 21.6661 27.8644 22.0864 27.8644 22.6049V30.2299C27.8644 30.7483 27.4441 31.1686 26.9257 31.1686C26.4072 31.1686 25.987 30.7483 25.987 30.2299V22.6049C25.987 22.0864 26.4072 21.6661 26.9257 21.6661Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1838 21.6661C11.7023 21.6661 12.1226 22.0863 12.1226 22.6048V30.2298C12.1226 30.7482 11.7023 31.1685 11.1838 31.1685C10.6654 31.1685 10.2451 30.7482 10.2451 30.2298V22.6048C10.2451 22.0863 10.6654 21.6661 11.1838 21.6661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3855 21.6661C29.9039 21.6661 30.3242 22.0864 30.3242 22.6049V30.2299C30.3242 30.7483 29.9039 31.1686 29.3855 31.1686C28.867 31.1686 28.4468 30.7483 28.4468 30.2299V22.6049C28.4468 22.0864 28.867 21.6661 29.3855 21.6661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1352 21.6661C14.6536 21.6661 15.0739 22.0864 15.0739 22.6049V30.2299C15.0739 30.7483 14.6536 31.1686 14.1352 31.1686C13.6167 31.1686 13.1965 30.7483 13.1965 30.2299V22.6049C13.1965 22.0864 13.6167 21.6661 14.1352 21.6661Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1592 26.0484C25.1592 26.5669 24.7389 26.9871 24.2205 26.9871H16.5955C16.077 26.9871 15.6567 26.5669 15.6567 26.0484C15.6567 25.53 16.077 25.1097 16.5955 25.1097H24.2205C24.7389 25.1097 25.1592 25.53 25.1592 26.0484Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7858 8.83005C20.0595 8.65835 20.4023 8.63947 20.6932 8.78007L27.6938 12.1637C28.018 12.3204 28.224 12.6488 28.224 13.0089C28.224 13.369 28.018 13.6974 27.6938 13.8541L21.2234 16.9814V30.2771C21.2234 30.7955 20.8031 31.2158 20.2847 31.2158C19.7662 31.2158 19.3459 30.7955 19.3459 30.2771V9.62525C19.3459 9.30215 19.5121 9.00176 19.7858 8.83005ZM21.2234 14.8962L25.1281 13.0089L21.2234 11.1216V14.8962Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.5054318f6d9f5761fd641bfa547a7026.svg";
export { ForwardRef as ReactComponent };